import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { LogoSmall } from 'Images';
import { Helmet } from 'react-helmet-async';

interface ICustomMetaTitle {
  title: string;
  disablePrefix?: boolean;
}

export const CustomMetaTitle = ({ title, disablePrefix }: ICustomMetaTitle) => {
  const pageTitle = disablePrefix
    ? title
    : Dictionary[DICTIONARY.MedicationsAndPrescriptionsLobby].personalZone +
      ' - ' +
      title;
  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta property='og:title' content={pageTitle} />
      <meta property='og:image' content={LogoSmall} />
    </Helmet>
  );
};
